export interface TickerOption {
  label: string
  bbgCompositeKey: string
  name: string
  legalName: string
  value: string
  status: string
}

export const TradeReasonsTreeData = [
  {
    value: 'Earnings event',
    title: 'Earnings event',
    disabled: true, // Add disabled property to make it not selectable
    children: [
      {
        value: 'Betting into earnings report',
        title: 'Betting into earnings report',
      },
      {
        value: 'Price under/over-react post earnings',
        title: 'Price under/over-react post earnings',
      },
    ],
  },
  {
    value: 'Events/Catalyst (none-earning)',
    title: 'Events/Catalyst (none-earning)',
    disabled: true, // Add disabled property to make it not selectable
    children: [
      {
        value: 'Betting into event/catalyst',
        title: 'Betting into event/catalyst',
      },
      {
        value: 'Price under/over-react post event/catalyst',
        title: 'Price under/over-react post event/catalyst',
      },
    ],
  },
  {
    value: 'Company fundamentals',
    title: 'Company fundamentals',
    disabled: true, // Add disabled property to make it not selectable
    children: [
      {
        value: 'Long term earnings',
        title: 'Long term earnings',
      },
      {
        value: 'Own firm research',
        title: 'Own firm research',
      },
      {
        value: 'Other firm research',
        title: 'Other firm research',
      },
    ],
  },
  {
    value: 'others',
    title: 'Others',
    disabled: true,
    children: [
      {
        value: 'Thematic',
        title: 'Thematic',
      },
      {
        value: 'Technical analysis',
        title: 'Technical analysis',
      },
      {
        value: 'Flows',
        title: 'Flows',
      },
      {
        value: 'Macro',
        title: 'Macro',
      },
      {
        value: 'Hedging (Funding Long/Funding Short)',
        title: 'Hedging (Funding Long/Funding Short)',
      },
      {
        value: 'Regulation (compliance/delisting/sanction)',
        title: 'Regulation (compliance/delisting/sanction)',
      },
    ],
  },
]

export const FillStrategies = [
  { value: '1hour-VWAP', label: '1hr-VWAP' },
  { value: 'Fullday-VWAP', label: 'VWAP till EOD' },
]
